/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2020-11-14 09:25:32
 */

import {IconBtnItem} from "src/components/iconBtnGroup/iconBtnGroup";
import {ColDefCustom, default as AgGridVueCustomTsx} from "src/components/agGridCustom/agGridVueCustomTsx";
import DataViewApi,{DataViewDOI} from "../api/dataViewApi";
import _ from 'lodash'
import ListPageService from 'src/types/ListPage';
import override from "src/dectorators/override";
import {QueryFormVOI} from "src/components/queryForm/queryForm";
import Input from 'src/types/iview/Input';
import EnumStationType from 'src/enums/enumStationType';
import DataViewDetailList from '../dataViewDetailList';
import DatePicker from 'src/types/iview/DatePicker';
import CommonSelect from 'src/components/SelectCustom/commonSelect';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import EnumUpsState from 'src/enums/enumUpsState';
import EnumInvertState from 'src/enums/enumInvertState';
import CellRenderTsx from 'src/components/agGridComponent/cellRenderTsx';
import SpanHead from "src/components/agGridComponent/spanHead";
import alertLimitsModal from "./limitsModal";

export default class DataViewDetailListService extends ListPageService {
    ctx: DataViewDetailList;
    
    get type() {
        return EnumStationType.findCode(this.ctx.$route.params.type).getId();
    }

	constructor (ctx: DataViewDetailList) {
	    super()
		this.ctx = ctx
	}

    @override
	createColumns (): ColDefCustom [] {
		return [
			{
				headerName: '时间',
				field: 'DateTime',
				minWidth: 160,
				// cellRendererFramework: CellRenderTsx,
                //  cellRendererFrameworkOpt:{
                //      cellRender(h, params) {
                //          return <div style={{color:"#E2014A"}}>{params.data.DateTime}</div>
                //      }
                //  }
			},
		]
	}

    createColumns3041 (): ColDefCustom [] {
		return [
			{
				headerName: '时间',
				field: 'DateTime',
				minWidth: 180
			},
            {
				headerName: '温度(℃)',
				field: 'Temp',
				minWidth: 80
			},
            {
				headerName: '湿度(%)',
				field: 'Hum',
				minWidth: 70
			},
			{
				headerName: '电池剩余容量(AH)',
				field: 'Elect',
				minWidth: 110
			},
			{
				headerName: '电池电压(V)',
				field: 'BattVolt',
				minWidth: 110
			},
			{
				headerName: '电池剩余百分比(%)',
				field: 'BattSurpl',
				minWidth: 130
			},
			{
				headerName: 'UPS状态',
				field: 'UpsState',
				minWidth: 110,
				cellRenderer(params) {
                    return EnumUpsState.findId(params.data.UpsState).getName();
                },
			},
			{
				headerName: '输入电压(V)',
				field: 'InputVolt',
				minWidth: 110
			},
			{
				headerName: '输出电压(V)',
				field: 'OutpVolt',
				minWidth: 110
			},
			{
				headerName: '逆控一体机状态',
				field: 'InvertState',
				minWidth: 110,
				cellRenderer(params) {
                    return EnumInvertState.findId(params.data.InvertState).getName();
                },
			},
            {
				headerName: '逆变电压(V)',
				field: 'InvertVolt',
				minWidth: 110
			},
			{
				headerName: '逆变电流(A)',
				field: 'InvertCur',
				minWidth: 110
			},
			{
				headerName: '逆变频率(Hz)',
				field: 'InvertFreq',
				minWidth: 110
			},
            {
				headerName: '电池可用时间(天)',
				field: 'BattLife',
				minWidth: 130
			},
            {
				headerName: '电量1(AH)',
				field: 'Elec1',
				minWidth: 100
			},
            {
				headerName: '电压1(V)',
				field: 'Volt1',
				minWidth: 100
			},
            {
				headerName: '电池余量1(%)',
				field: 'BattSurP1',
				minWidth: 110
			},
            {
				headerName: '电量2(AH)',
				field: 'Elec2',
				minWidth: 100
			},
            {
				headerName: '电压2(V)',
				field: 'Volt2',
				minWidth: 100
			},
            {
				headerName: '电池余量2(%)',
				field: 'BattSurP2',
				minWidth: 110
			},
            {
				headerName: '电量3(AH)',
				field: 'Elec3',
				minWidth: 100
			},
            {
				headerName: '电压3(V)',
				field: 'Volt3',
				minWidth: 100
			},
            {
				headerName: '电池余量3(%)',
				field: 'BattSurP3',
				minWidth: 110
			},
            {
				headerName: '电量4(AH)',
				field: 'Elec4',
				minWidth: 100
			},
            {
				headerName: '电压4(V)',
				field: 'Volt4',
				minWidth: 100
			},
            {
				headerName: '电池余量4(%)',
				field: 'BattSurP4',
				minWidth: 110
			}
		]
	}

    @override
	createBtnGroup (): Array<IconBtnItem> {
		return []
	}

    creatQueryForm(): QueryFormVOI.DateItemType[] {
        let t = this
        return [
            {
				component: CommonSelect,
				label: '数据类型',
                field: 'cn',
                width: 250,
                hide: true,
                props: {value: '', dataSource: t.ctx.dataType},
            },
            {
				component: DatePicker,
				label: '时间',
                field: 'time',
                width: 300,
                realField: ['start_time','end_time'],
                timeType: 'number',
                props: {value: DateTimeUtil.getDayInterval(7), type: 'daterange', format: 'yyyy-MM-dd',placeholder: '请选择时间'},
            }
                
        ];
    }


	@override
	initSearchParams (): void {
		this.ctx.searchParams = {
            ...this.ctx.queryForm.getQueryObj<DataViewDOI.QueryDetailParamsI>(),
            mn: this.ctx.mn,
        }
        if(!this.ctx.searchParams.cn) {
            this.ctx.searchParams.cn = this.ctx.currentDataType
        }
		this.ctx.currentPage = 1
	}

    @override
	async searchTable () {
		let ctx = this.ctx
		let ag = (this.ctx.$refs.ag) as AgGridVueCustomTsx
		if(ctx.searchParams["mn"] == ""){
			return;
		}
		ag.showLoading()
		let {code, data} = await DataViewApi.searchDetailList({
            ...ctx.searchParams,
			page_size: ctx.pageSize,
			page_index: ctx.currentPage
		})
		ag.hideLoading()

		if (code === 0) {
            if(this.ctx.searchParams.cn == "3041"){
                ctx.columnDefs = [
                    ...this.createColumns3041(),
                ];
            }else{
				ctx.columnDefs = [
					...this.createColumns(),
					...data.header.map(i =>  i.key.includes("deviation_value") ? ({
						headerName: `${i.name}`,
						field: i.key,
						minWidth: 135,
						cellRendererFramework: CellRenderTsx,
                        cellRendererFrameworkOpt:{
                            cellRender(h, params) {
								var key = i.key.split('-')[0] + "-is_qualified"
								if(params.data[key]){
									return <div style={{color:"#fff"}}>{params.data[i.key]}</div>
								}
								else{
									return <div style={{color:"#E2014A"}}>{params.data[i.key]}</div>
								}
                            }
                        }
					}):
					({
						headerName: `${i.name}(${i.unit})`,
						field: i.key,
						minWidth: 135,
						headerComponentFramework: SpanHead,
                        headerComponentFrameworkOpt: {
                            showSelect: true,
                            onCheck: this.onCheck.bind(this),
                            selected: false,
                            indeterminate: false,
                        },
					})
					),
				];
            }
            ctx.rowData = data.body || [];
            ctx.total = data.page_count
		}
    }

	async onCheck(v, params) {
		var list = await DataViewApi.getLimits(this.ctx.mn)
		var key = params.column.colId;
		if(params.column.colId.includes("-")){
			key = params.column.colId.split("-")[0];
		}
		list.data.forEach(item => {
			if(item.key == key){
				alertLimitsModal(item.alarm_floor, item.alarm_ceiling);;
			}
		});
	}
    
    async queryAllDataType() {
        let {data, code} = await DataViewApi.searchDataType()
        if(code === 0) {
			if(this.type != 2)
			{
				this.ctx.allDataType = [...data.map(i=> ({name: i.data_name, value: i.cn}))]
			}
            // this.ctx.currentDataType = data[0].cn
        }
    }

    async queryDataType() {
        let {data, code} = await DataViewApi.searchDataTypeRelation(+this.ctx.$route.query.productId)
        if(code === 0) {
			if(this.type != 2)
			{
                this.ctx.dataType = data.filter(i=>i.type===2).map(i=> ({name: i.data_name, id: i.cn}))
                if(this.ctx.dataType.length>0) {
                    this.ctx.queryFormData[0].props.dataSource = this.ctx.dataType
                    this.ctx.allDataType = [...this.ctx.allDataType, {name: '质控数据', value: ''},{name: '手工数据', value: '11000'},{name: '动环系统', value: '3041'}]
                }
			}
			else{
				this.ctx.allDataType = [{name: '测量数据', value: '2082'}]
				this.ctx.allDataType.push({name: '手工数据', value: '11000'})
			}
        }
    }

}